export class DefaultBulkUploadShow {
  validationMessage: DefaultBulkUploadShowValidationMessage;
  title: {
    header: string;
    info: {
      main: string;
      sub: string;
    };
  };
}

export class DefaultBulkUploadShowValidationMessage {
  upperText: string;
  bottomText: string;
}

export class DefaultBulkUploadIs {
  applyActivated = false;
  dataUploaded = false;
  uploadDisabled = true;
}
